import { connect } from "react-redux";
import PaymentMethodsCode from "./PaymentMethodsCode";
import { withRouter } from "react-router-dom";
import EntityPage from "../../components/EntityPage";


class PaymentMethods extends EntityPage {

    constructor() {
        super('admin_local.menus.cashRegisters');
        this.code = new PaymentMethodsCode()
    }

}
const mapStateToProps = (props, state) => {
    if (props.rootReducer.myStatus && props.rootReducer.myStatus.restaurant_id) {
        return {
            restaurant: props.rootReducer.restaurant,
            myStatus: props.rootReducer.myStatus,
            admin_local: props.rootReducer.admin_local,
            local: props.rootReducer.local,
            speechRecognitionOn: props.rootReducer.speechRecognitionOn,
            ai: props.rootReducer.ai,
            speechRecognitionAvailable: props.rootReducer.speechRecognitionAvailable,
        };
    }
    return {};
};

export default connect(mapStateToProps)(withRouter(PaymentMethods));
